import graphqlRequest from "../badgingRequest";
import UPDATE_BADGE from "./updateBadgeGraphql";

export async function updateBadge(payload) {
  const response = await graphqlRequest(UPDATE_BADGE, payload);
  return response.updateStudentBadge;
}